export var RESOLVE_METHOD = /*#__PURE__*/function (RESOLVE_METHOD) {
  RESOLVE_METHOD["COMPONENT"] = "component";
  RESOLVE_METHOD["CONSUMER"] = "consumer";
  RESOLVE_METHOD["ORPHANED"] = "orphaned";
  return RESOLVE_METHOD;
}({});
export var VIEW_METHOD = /*#__PURE__*/function (VIEW_METHOD) {
  VIEW_METHOD["BADGE"] = "badge";
  VIEW_METHOD["COMMENT_BUTTON"] = "commentButton";
  return VIEW_METHOD;
}({});